import { useAuth } from '@teko/auth-react';
import { logger } from '@teko/log';
import { NetworkConfig } from '@teko/loyalty';
import { useServices, useTenantConfig } from 'contexts';
import useSWR from 'swr';

export const useNetworkConfig = () => {
  const { loyaltyBFFService } = useServices();
  const { needToCheckLoyaltyMemberId } = useTenantConfig();
  const { user } = useAuth();

  const { data, isValidating, mutate } = useSWR<NetworkConfig | undefined>(
    ['/networkConfig', user?.id],
    async () => {
      try {
        // call getNetworkConfig only when user account had phone number
        const shouldFetchLoyaltyInfo = !!needToCheckLoyaltyMemberId
          ? user?.telephone && user?.loyaltyMemberId
          : user?.telephone;
        if (!shouldFetchLoyaltyInfo) return undefined;
        return await loyaltyBFFService.getNetworkConfig();
      } catch (e) {
        logger.error(`Error occur when fetching network config: ${e}`);
        return undefined;
      }
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      shouldRetryOnError: false,
      dedupingInterval: 5000,
    },
  );

  return {
    networkConfig: data,
    refetchNetworkConfig: mutate,
    loading: isValidating,
  };
};
